"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _gatsbyPluginImage = require("gatsby-plugin-image");

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var GatsbyImage = function GatsbyImage(props) {
  var _image$localFile, _image$localFile$chil, _image$localFile$chil2, _image$localFile$chil3, _image$localFile$chil4;

  var image = props.image,
      _props$alt = props.alt,
      alt = _props$alt === void 0 ? '' : _props$alt,
      objectFit = props.objectFit,
      imgStyle = props.imgStyle,
      rest = (0, _objectWithoutProperties2.default)(props, ["image", "alt", "objectFit", "imgStyle"]);

  if (image !== null && image !== void 0 && image.svg) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _htmlReactParser.default)(image.svg));
  }

  var id = (image === null || image === void 0 ? void 0 : image.id) || (image === null || image === void 0 ? void 0 : image.sourceUrl) || (image === null || image === void 0 ? void 0 : (_image$localFile = image.localFile) === null || _image$localFile === void 0 ? void 0 : (_image$localFile$chil = _image$localFile.childImageSharp) === null || _image$localFile$chil === void 0 ? void 0 : (_image$localFile$chil2 = _image$localFile$chil.gatsbyImageData) === null || _image$localFile$chil2 === void 0 ? void 0 : (_image$localFile$chil3 = _image$localFile$chil2.images) === null || _image$localFile$chil3 === void 0 ? void 0 : (_image$localFile$chil4 = _image$localFile$chil3.fallback) === null || _image$localFile$chil4 === void 0 ? void 0 : _image$localFile$chil4.src);
  var component = (0, _react.useMemo)(function () {
    if (image !== null && image !== void 0 && image.localFile) {
      return /*#__PURE__*/_react.default.createElement(_gatsbyPluginImage.GatsbyImage, (0, _extends2.default)({}, rest, {
        objectFit: objectFit,
        imgStyle: imgStyle,
        image: (0, _gatsbyPluginImage.getImage)(image.localFile),
        alt: alt
      }));
    } else if (image !== null && image !== void 0 && image.sourceUrl) {
      return /*#__PURE__*/_react.default.createElement(_gatsbyPluginImage.GatsbyImage, (0, _extends2.default)({}, rest, {
        objectFit: objectFit,
        imgStyle: imgStyle,
        image: {
          height: image === null || image === void 0 ? void 0 : image.height,
          width: image === null || image === void 0 ? void 0 : image.width,
          images: {
            fallback: {
              sizes: (image === null || image === void 0 ? void 0 : image.sizes) || '',
              srcSet: (image === null || image === void 0 ? void 0 : image.srcSet) || '',
              src: image.sourceUrl
            },
            sources: [{
              sizes: (image === null || image === void 0 ? void 0 : image.sizes) || '',
              srcSet: (image === null || image === void 0 ? void 0 : image.srcSet) || '',
              type: (image === null || image === void 0 ? void 0 : image.mediaType) || 'image'
            }]
          },
          layout: 'constrained',
          placeholder: {
            fallback: ''
          }
        },
        alt: alt
      }));
    } else {
      return null;
    }
  }, [id, objectFit, imgStyle]);
  return component;
};

var _default = GatsbyImage;
exports.default = _default;